import React, { useEffect, useState, useMemo, useCallback } from 'react';
import SortOptions from '../../../_SharedComponents/SortOptions.jsx';
import GameItem from '../../../_SharedComponents/GameItem.jsx';
import ThemesComponent from '../../../_SharedComponents/ThemesComponent.jsx';
import Overlooked from '../../../_SharedComponents/Overlooked.jsx';
import Loader from '../../../_SharedComponents/Loader.jsx';

export default function Themes(props) {
    const config = require("Config");
    const {
        session,
        games,
        brands,
        tags,
        categories,
        sortOptions,
        isDesktop,
        theme,
        themes,
        sendThemeFn
    } = props;

    const [activeSort, setActiveSort] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [localStorageSortKey, setLocalStorageSortKey] = useState(null);

    useEffect(() => {
        window.parent.postMessage({ type: "scrollToTop", scroll: true }, "*");

        if (theme) {
            const localStorageSortKey = "tema_" + theme.tag + "_sort";
            const activeSortID = parseInt(localStorage.getItem(localStorageSortKey));
            setLocalStorageSortKey(localStorageSortKey);
            setActiveSort(activeSortID);
        }
    }, [theme]);

    const sendUrlParameter = useCallback((url) => {
        setTimeout(() => {
            window.parent.postMessage({ type: "urlParameter", urlParam: url }, "*");
        }, 150);
    }, []);

    const renderGames = useCallback((game, index) => {
        return (
            <GameItem
                key={index}
                session={session}
                game={game}
                brands={brands}
                categories={categories}
                goLazyImage={true}
                showJackpot={true}
                isDesktop={isDesktop}
                restApiUrl={config.restApiUrl}
                apiKey={config.apiKey}
                icon={null}
                textColor={false}
            />
        );
    }, [session, brands, categories, isDesktop, config]);

    const renderThemes = useCallback((themeItem, index) => {
        return (
            <button
                key={`theme-${index}`}
                className={`theme ${themeItem.code}`}
                onClick={() => sendThemeFn(themeItem.code)}
            >
                <h3>{themeItem.name}</h3>
                <div className="content">
                    {isDesktop && (
                        <>
                            <div
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent outer button click
                                    sendThemeFn(themeItem.code);
                                }}
                                className="prikazi-sve-btn"
                            >
                                Prikaži igre
                            </div>
                            <p>{themeItem.description}</p>
                        </>
                    )}
                </div>
                <div className="png-image"></div>
            </button>
        );
    }, [isDesktop]);

    const filteredGames = useMemo(() => {
        if (!theme || !tags) return [];

        const tagId = Object.keys(tags).find((key) => tags[key] === theme.tag);
        const tagIdInt = parseInt(tagId);
        const search = searchText.toLowerCase();

        let themeGames = games?.filter((game) => game.t?.hasOwnProperty(tagIdInt))
            .sort((x, y) => (x.kt['9'] > y.kt['9'] ? 1 : -1));

        if (search) {
            themeGames = themeGames.filter((x) => x.n.toLowerCase().includes(search));
        }

        return themeGames.sort((a, b) => {
            if (activeSort === 2) return a.so[0] > b.so[0] ? -1 : 1;
            if (activeSort === 3) return a.so[1] > b.so[1] ? -1 : 1;
            if (activeSort === 4) return a.n < b.n ? -1 : 1;
            return 0;
        });
    }, [games, tags, theme, searchText, activeSort]);

    const sortGamesOnClick = useCallback((sortId) => {
        localStorage.setItem(localStorageSortKey, sortId);
        setActiveSort(sortId);
    }, [localStorageSortKey]);

    const renderThemesList = () => (
        <div className="themes">
            {themes?.map((themeItem, index) => renderThemes(themeItem, index))}
        </div>
    )

    const renderSearchAndSort = () => (
        <div className={!isDesktop ? "games-container mobile" : "games-container"}>
            {!isDesktop && (
                <input
                    type="text"
                    placeholder="Pretraži igre"
                    className="search-games"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                />
            )}
            <SortOptions
                sortGamesOnClick={sortGamesOnClick}
                sortOptions={sortOptions}
                activeSort={activeSort}
                localStorageKey={localStorageSortKey}
                defaultCategorySort={0}
                positionLeft={!isDesktop}
                isDesktop={isDesktop}
            />
        </div>
    )

    const renderGamesList = () => {
        return (
            <div className={`games-container ${!isDesktop ? "mobile" : "full"}`}>
                {filteredGames.map((game, index) => renderGames(game, index))}
            </div>
        )
    }

    const renderComponents = () => (
        <>
            <ThemesComponent
                themes={themes}
                activeTheme={theme}
                games={games}
                tags={tags}
                config={config}
                session={session}
                brands={brands}
                categories={categories}
                isDesktop={isDesktop}
                sendThemeFn={sendThemeFn}
                sendUrlParameter={sendUrlParameter}
            />
            <Overlooked
                categories={categories}
                sendUrlParameter={sendUrlParameter}
                session={session}
                isDesktop={isDesktop}
            />
        </>
    )

    return (
        <div className="themes-wrapper">
            <h1>{!theme ? "Teme" : theme.name}</h1>
            {!theme ? (
                renderThemesList()
            ) : (
                <>
                    <div className="themes">
                        {renderSearchAndSort()}
                        {!games && !tags ? <Loader/> : renderGamesList()}
                    </div>
                        {!categories ? <Loader /> : renderComponents()}
                </>
            )}
        </div>
    );
}